import { Fragment } from 'react';

import { SmartTableCellProps } from '@/components/ui/daisy';
import { formatLessonName } from '@/utils/lesson/name';

import { ScheduledLessonWithKlass } from '../types';

export default function LessonCell({
  item,
}: SmartTableCellProps<ScheduledLessonWithKlass>) {
  const lessonName = formatLessonName(item.lesson, {
    ...item,
    klass: item.klass.id,
  });

  return <Fragment>{lessonName}</Fragment>;
}
